import axios from "../../axiosDod.js";

const addDodOrder = async ({ dispatch }, data) => {
  const response = await axios.post(`orders`, data);
  dispatch("fetchStatusesCounters");
  return response.data;
};

const editDodOrder = async ({ dispatch }, payload) => {
  const { data, orderId } = payload;
  const response = await axios.put(`orders/${orderId}`, data);
  dispatch("fetchStatusesCounters");
  return response.data;
};

const deleteDodOrder = async ({ dispatch }, payload) => {
  const { orderId, year, month } = payload;
  const params = { year, month };
  const response = await axios.delete(`orders/${orderId}`, { params });
  await dispatch("fetchStatusesCounters");
  return response.data;
};

const getDodOrdersInMonth = async ({ commit, getters }, data) => {
  const {
    month,
    year,
    filters,
    search,
    employeeId,
    customerId,
    limit,
    page,
  } = data;
  const customerFetchParams = getters.getDodCustomerFetchParams;
  const params = {
    limit: limit || Number.MAX_SAFE_INTEGER,
    page: page,
    month: month || customerFetchParams.ordersMonth,
    year: year || customerFetchParams.ordersYear,
  };
  if (search) {
    params.search = search;
  }
  if (filters) {
    for (const [key, value] of Object.entries(filters)) {
      params[key] = value;
    }
  }
  if (employeeId) {
    params.employeeId = employeeId;
  }
  if (customerId) {
    params.customerId = customerId;
  }
  const response = await axios.get(`orders`, { params });
  if (!employeeId && !customerId) {
    commit("SET_ORDERS_IN_MONTH", response.data);
  } else if (employeeId) {
    commit("SET_DOD_SELECTED_EMPLOYEE_REPORTS_ORDERS", response.data);
  } else if (customerId) {
    commit("SET_DOD_SELECTED_CUSTOMER_REPORTS_ORDERS", response.data);
  }
  return response.data;
};

const updateOrderDayHours = async (_, data) => {
  const response = await axios.put(`orders/hours`, data);
  if (response && response.data) {
    return true;
  } else {
    return false;
  }
};

const fetchSettlementSummaryForMonth = async ({ commit }, data) => {
  const { month, year } = data;
  const params = { month, year };
  const response = await axios.get(`orders/settlementSummaryForMonth`, {
    params,
  });
  commit("SET_SETTLEMENT_SUMMARY_FOR_MONTH", response.data);
  return response.data;
};

// Ekran walidacyjny przed zamknieciem miesiaca: panel oddaje godziny i stawki, SeniorApp
// dolicza prowizje z profilu opiekunki i liczy netto tym samym zaokragleniem, ktorym wyplaca.
// Nic nie jest zapisywane - to podglad tego, co zrobi finishOrdersInSeniorApp.
const previewFinishOrdersInSeniorApp = async ({ commit }, data) => {
  const response = await axios.post(`orders/previewFinishOrdersInSeniorApp`, data);
  commit("SET_DNR_FINISH_PREVIEW", response.data);
  return response.data;
};

const finishOrdersInSeniorApp = async (_, data) => {
  const response = await axios.post(`orders/finishOrdersInSeniorApp`, data);
  return response.data;
};

const removeSingleDay = async (_, data) => {
  const response = await axios.put(`orders/removeSingleDay`, data);
  return response.data;
};

export default {
  addDodOrder,
  getDodOrdersInMonth,
  updateOrderDayHours,
  editDodOrder,
  deleteDodOrder,
  fetchSettlementSummaryForMonth,
  previewFinishOrdersInSeniorApp,
  finishOrdersInSeniorApp,
  removeSingleDay,
};
